<template>
  <div>
    <prediag-test-question mode="TEST" :answers="answers" @check="onCheck"/>
    <div class="text-center my-3"><mdb-btn icon="check" :disabled="!isOk" @click="onOk">확인</mdb-btn></div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import PrediagTestQuestion from './PrediagTestQuestion.vue';
export default {
  name: 'PrediagTest',
  components: { PrediagTestQuestion },
  data: () => ({
    answers: Array(10)
  }),
  computed: {
    ...mapState('auth', ['profile']),
    isOk () {
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i] === undefined) return false
      }
      return true
    }
  },
  methods: {
    onCheck (ix, score) {
      this.answers = [...this.answers]
      this.answers[ix] = score
    },
    onOk () {
      if (!confirm('제출할까요?')) return
      this.$emit('save-test', this.answers)
    }
  }
}
</script>
